import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function usersReducer(state = initialState.user, action){
    let userObject = {};
    switch(action.type){
      case types.LOGIN_USER_SUCCESS:
        localStorage.setItem('aToken', action.user.token);
      return {isLoggedIn: true};
      case types.LOGOUT_USER_SUCCESS:
        localStorage.removeItem('aToken');
      return {isLoggedIn: false}
      default:
      return state;
    }
}
